/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Swap Icon component.
 */
export const SwapIcon = React.memo((props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 17 16' fill='none'>
      <path d="M11.0198 6.66809L13.3497 4.13901L11.0198 1.71447" stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
      <path d="M2.40918 8.25839V4.28088C2.40918 4.00474 2.63304 3.78088 2.90918 3.78088H12.3975" stroke={iconColor} strokeWidth='1.5' strokeLinecap='round'/>
      <path d="M5.77222 9.33209L3.44227 11.8612L5.77222 14.2857" stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
      <path d="M14.3828 7.74179V11.7193C14.3828 11.9954 14.159 12.2193 13.8828 12.2193H4.39453" stroke={iconColor} strokeWidth='1.5' strokeLinecap='round'/>
    </svg>
  );
});
